// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box-style[data-v-54acafaa] {\n  padding: 10px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  font-family: Arial, Helvetica, sans-serif;\n}\n", ""]);
// Exports
module.exports = exports;
